<style lang="less">
    .lendRecord{
        border: 1px solid #d7dde4;
        background: #efefef;
        height: 100%;
        position: relative;
        .head{
            /*height: 46px;*/
            padding-top: 10px;
            margin-bottom: 20px;
            h1{
                display: inline;
                margin-left: 20px;
                };
            .searchArea{
                /*display: inline-block;*/
                margin-left: 20px;
                margin-top: 10px;
            }
        }
        .layout-breadcrumb{
            padding: 10px 15px 0px ;
            /*border-bottom: 1px solid #e3e3e3;*/
        }
        .layout-content{
            min-height: 80vh;
            margin: 15px;
            overflow: hidden;
            background: #fff;
            border-radius: 4px;
        }
        .layout-content-main{
            padding: 10px;
        }
        .table th{
            background-color: #00c0ff;
            color: #fff;
        }
        .footer{
            margin-top: 10px;
            width: 100%;
            height: 46px;
        }

    }
    .ivu-table .demo-table-info-row td{
        color: #f50807;
    }



</style>
<template>
    <div class="lendRecord">
        <Row>
            <i-col span="24">
                <div class="layout-breadcrumb">
                    <Breadcrumb>
                        <BreadcrumbItem >资产管理</BreadcrumbItem>
                        <BreadcrumbItem >借出记录列表</BreadcrumbItem>
                    </Breadcrumb>
                </div>
                <div class="layout-content">
                    <div class="layout-content-main">
                        <div class="head">
                            <h1 >借出记录列表</h1>
                            <div class="searchArea">
                                <!--<Form ref="formInline" :model="formInline" inline :label-width="100">-->
                                    <!--<Form-item label="固定资产名称">-->
                                        <!--<Input  v-model="ql_name"></Input>-->
                                    <!--</Form-item>-->
                                    <!--<Form-item label="所属部门">-->
                                        <!--<Select v-model="ql_department" clearable style="width:162px;">-->
                                            <!--<Option v-for="item in departmentList" :value="item.name" :key="item.name">{{ item.name }}</Option>-->
                                        <!--</Select>-->
                                    <!--</Form-item>-->
                                    <!--<Form-item label="借出部门">-->
                                        <!--<Select v-model="ql_lend_department" clearable style="width:162px;display: inline-block">-->
                                            <!--<Option v-for="item in departmentList" :value="item.name" :key="item.name">{{ item.name }}</Option>-->
                                        <!--</Select>-->
                                    <!--</Form-item>-->
                                    <!--<Form-item label="借出时间">-->
                                        <!--<DatePicker  type="date" placeholder="请选择开始时间" v-model="startDate" formate="yyyy-MM-dd" @on-change="setDate('startDate',$event)"></DatePicker>-->
                                    <!--</Form-item>-->

                                    <!--<Button type="primary" @click="search">查询</Button>-->
                                <!--</Form>-->
                                固定资产名称:
                                <Input  v-model="ql_name" style="display: inline-block;width: 150px;"></Input>
                                <!--<DatePicker  type="date" placeholder="请选择开始时间" v-model="startDate" formate="yyyy-MM-dd" @on-change="setDate('startDate',$event)"></DatePicker>-->
                                所属部门:
                                <Select v-model="ql_department" clearable style="width:150px;display: inline-block">
                                    <Option v-for="item in departmentList" :value="item.name" :key="item.name">{{ item.name }}</Option>
                                </Select>
                                借出部门:
                                <Select v-model="ql_lend_department" clearable style="width:150px;display: inline-block">
                                    <Option v-for="item in departmentList" :value="item.name" :key="item.name">{{ item.name }}</Option>
                                </Select>
                                <!--借出时间:-->
                                <!--<DatePicker  type="date" placeholder="请选择开始时间" v-model="startDate" formate="yyyy-MM-dd" @on-change="setDate('startDate',$event)"></DatePicker>-->
                                <Button type="primary" @click="search">查询</Button>
                            </div>
                        </div>
                        <Table border :columns="columns1" class="table" :row-class-name="rowClassName"  :data="dataSourceList" ref="table"></Table>

                    </div>
                </div>
                <div class="footer">
                    <Page
                            class="pull-right"
                            :total="totalSize"
                            :current="page"
                            size="small"
                            show-total
                            @on-change="changePage"
                            :page-size='pageSize'
                    ></Page>
                </div>

            </i-col>

        </Row>
    </div>

</template>

<script>
    export default {
        data () {
            return {
                loadDataUrl:'manage/waterrec/weixin_list',
                percent: 0,
                username:'',
                startDate:'',
                endDate:'',
                ql_name:'',
                ql_department:'',
                ql_lend_department:'',
                recordPage: {
                    current: 1,
                    pageSize: 20,
                    total: 0
                },
                formInline:{},
                totalSize:0,
                pageSize:14,
                page:1,
                dataSourceList:[],
                departmentList:[],
                columns1: [
//                    {
//                        title: '用友系统卡片编号',
//                        key: 'DataTime',
//                        align: 'center'
//                    },
                    {
                        title: '固定资产名称',
                        key: 'name',

                        align: 'center'
                    },
                    {
                        title: '借出部门',
                        key: 'lend_department',
                        align: 'center'
                    },
                    {
                        title: '借出人',
                        key: 'lender',
                        align: 'center'
                    },
                    {
                        title: '借出单位',
                        key: 'lend_company',
                        align: 'center',
                    },
                    {
                        title: '借出时间',
                        key: 'lend_time',
                        align: 'center'
                    },
                    {
                        title: '归还时间',
                        key: 'return_time',
                        align: 'center'
                    },
                    {
                        title: '备注',
                        key: 'remarks',
                        align: 'center'
                    },
                    {
                        title: '操作',
                        key: 'action',
                        align: 'center',
                        render: (h, params) => {
                        let rowData = params.row;
                            if(rowData.return_time!=''){
                                return h('div', [
                                    h('Button', {
                                        props: {
                                            size: 'small',
                                            disabled:true
                                        },
                                        style: {
                                            marginRight: '5px',
                                        },
                                    }, '已归还'),
                                ]);
                            }else{
                                return h('div', [
                                    h('Button', {
                                        props: {
                                            type: 'primary',
                                            size: 'small'
                                        },
                                        style: {
                                            marginRight: '5px'
                                        },
                                        on: {
                                            click: () => {
                                            this.sendBack(params.index)
                                    }
                            }
                            }, '确定归还'),
                            ]);
                            }

                        }
                    },

                ],
            }

        },
        methods: {
            //渲染未归还行颜色
            rowClassName (row,index) {
                var that =this;
                for(var i=0;i<this.dataSourceList.length;i++){
                    if(that.dataSourceList[i].return_time==""&& index == i){
                        return 'demo-table-info-row';
                    }
                }
            },
            //部门列表
            getDepartment:function () {
                var that = this;
                var params = {};
                params.data = {};
                params.token = this.getKey('token');
                params.url = '/sys/department/list';
                params.success = function(res) {
                    that.$Loading.finish();
                    console.log(res);
                    that.departmentList = res.data.result.result;
//                    that.recordPage.total = res.result.totalSize
//                    that.dataSourceList.reverse()

                }
                this.ajaxPost(params);
            },

            //设置日期
            setDate:function (type,value) {
                switch (type){
                    case 'startDate':
                        this.startDate = value ;
                        console.log(this.startDate);
                        break;
                    case 'endDate':
                        if(value == ''){
                            this.endDate = value;
                        }else {
                            let date = new Date(value);
                            date.setDate(date.getDate());
                            this.endDate = date.format("yyyy-MM-dd");
                            console.log(this.endDate);
                        }
                        break;
                }
            },
            //查询
            search:function (page) {
                var that=this;
                var params = {};
                if(this.ql_department==undefined){
                    this.ql_department='';
                }
                if(this.ql_lend_department==undefined){
                    this.ql_lend_department='';
                }
                params.data = {
                    "searchValue":{department:that.ql_department+'|#|like',name:that.ql_name+'|#|like',lend_department:that.ql_lend_department+'|#|like'},
                    "order":{"_id":-1},
                    pageSize:this.pageSize,
                };
              if(page === undefined || page === "" || isNaN(page)){
                params.data.page = 1;
              }else{
                params.data.page = page;
              }
                params.token = this.getKey('token');
                params.url = '/sys/lendrecord/list';
                console.log(params.data);
                params.success = function(res) {
                    console.log(res);
                    that.$Loading.finish();
                    that.totalSize=res.data.result.totalSize;
                    that.page=res.data.result.page;
                    that.dataSourceList = res.data.result.result;
                }
                this.ajaxPost(params);
            },
            //加载数据
            loadData: function(page){
                var that = this;
                var params = {};
                this.startDate=new Date(this.startDate).format('yyyy-MM-dd');
                this.endDate=new Date(this.endDate).format('yyyy-MM-dd');
//                page = page == '' || page == undefined?this.page:page;
                params.data = {
//                    "searchValue":{DataTime:that.startDate+' 00:00:00 |#|'+that.endDate+' 23:59:59'},
                    "order":{"_id":-1},
                    pageSize:this.pageSize,
                    page:page
                };
                if(page === undefined || page === "" || isNaN(page)){
                    params.data.page = 1;
                }else{
                    params.data.page = page;
                }
                params.token = this.getKey('token');
                params.url = '/sys/lendrecord/list';
                params.success = function(res) {
                    that.$Loading.finish();
                    console.log(res);
                    that.totalSize=res.data.result.totalSize;
                    that.page=res.data.result.page;
                    that.dataSourceList = res.data.result.result;

                }
                this.ajaxPost(params);

            },
            sendBack:function (index) {
                var that = this;
                var params = {};
                this.dataSourceList[index].return_time=new Date().format('yyyy-MM-dd');
                params.data = this.dataSourceList[index];
                params.token = this.getKey('token');
//                params.url = '/sys/lendrecord/edit';
                params.url = '/sys/lendrecord/returnland';
                console.log(params.data);
                params.success = function(res) {
                    that.$Loading.finish();
                    console.log(res);
                    that.$Notice.success({
                        title: '归还成功'
                    });
                    that.loadData()
//                    that.totalSize=res.result.totalSize;
//                    that.page=res.result.page;

                }
                this.ajaxPost(params);
            },
            changePage: function(page) {
                this.search(page);
            },
        },
        mounted: function () {
            this.getDepartment();
            this.loadData()

        }
    }
</script>



// WEBPACK FOOTER //
// src/components/propertyMana/lendRecord.vue